const dialog       = require ('../../components/dialog/dialog')
const fullcont     = require('./fullcont')
const snack        = require ('../../components/snack/snack')
const customerfullcont         = require('../../applications/staff/desktop/entity/customer/customer-fullcont')
const providerfullcont         = require('../../applications/staff/desktop/entity/provider/provider-fullcont')
const accountsfullcont         = require('../../applications/staff/desktop/entity/accounts/accounts-fullcont')
const areasfullcont            = require('../../applications/staff/desktop/entity/areas/areas-fullcont')
const investorfullcont         = require('../../applications/staff/desktop/entity/investor/investor-fullcont')
const investordepositfullcont  = require('../../applications/staff/desktop/entity/investordeposit/investordeposit-fullcont')
const itemfullcont             = require('../../applications/staff/desktop/entity/item/item-fullcont')
const item_unitfullcont        = require('../../applications/staff/desktop/entity/item_unit/item_unit-fullcont')
const otherexpensefullcont     = require('../../applications/staff/desktop/entity/otherexpense/otherexpense-fullcont')
const purchasefullcont         = require('../../applications/staff/desktop/entity/purchase/purchase-fullcont')
const receivepaymentfullcont   = require('../../applications/staff/desktop/entity/receivepayment/receivepayment-fullcont')
const customercreditfullcont   = require('../../applications/staff/desktop/entity/customercredit/customercredit-fullcont')
const salefullcont             = require('../../applications/staff/desktop/entity/sale/sale-fullcont')
const sentpaymentfullcont      = require('../../applications/staff/desktop/entity/sentpayment/sentpayment-fullcont')
const providercreditfullcont   = require('../../applications/staff/desktop/entity/providercredit/providercredit-fullcont')
const shipperfullcont          = require('../../applications/staff/desktop/entity/shipper/shipper-fullcont')
const usersfullcont            = require('../../applications/staff/desktop/entity/users/users-fullcont')
const companyfullcont          = require('../../applications/staff/desktop/entity/company/company-fullcont')
const employesspaymentfullcont = require('../../applications/staff/desktop/entity/employesspayment/employesspayment-fullcont')
const equitydepositfullcont = require('../../applications/staff/desktop/entity/equitydeposit/equitydeposit-fullcont')
const purchaseFullcont2 = require("../../applications/staff/desktop/entity/accountsPayable/purchase2/purchase-fullcont.js");
const saleFullcont2 = require("../../applications/staff/desktop/entity/accountsReceivable/sale2/sale-fullcont.js");
const purchaseFullcont3 = require("../../applications/staff/desktop/entity/providerProfit/purchase2/purchase-fullcont.js");
const saleFullcont3 = require("../../applications/staff/desktop/entity/customerProfit/sale2/sale-fullcont.js");

//C:\xampp\htdocs\GosiveFW\production\applications\staff\desktop\entity\services

export function findDest (detail) { //console.log('dt-web-scocket>', detail)

    switch (detail.dest){

        case 'customer':         customerfullcont.start({      dest: detail.dest, entity: detail.entity, act:'selectOne', id: 'customer-fullcont',     dbid: detail.id  });                 break;
        case 'provider':         providerfullcont.start({      dest: detail.dest, entity: detail.entity, act:'selectOne', id: 'provider-fullcont',     dbid: detail.id  });                 break;
        case 'accounts':         accountsfullcont.start({      dest: detail.dest, entity: detail.entity, act:'selectOne', id: 'accounts-fullcont',     dbid: detail.id  });                 break;
        case 'areas':            areasfullcont.start({      dest: detail.dest, entity: detail.entity, act:'selectOne', id: 'areas-fullcont',     dbid: detail.id  });                       break;
        case 'investor':         investorfullcont.start({      dest: detail.dest, entity: detail.entity, act:'selectOne', id: 'investor-fullcont',     dbid: detail.id  });                 break;
        case 'investordeposit':  investordepositfullcont.start({      dest: detail.dest, entity: detail.entity, act:'selectOne', id: 'investordeposit-fullcont',     dbid: detail.id  });   break;
        case 'item':             itemfullcont.start({      dest: detail.dest, entity: detail.entity, act:'selectOne', id: 'item-fullcont',     dbid: detail.id  });                         break;
        case 'item_unit':        item_unitfullcont.start({      dest: detail.dest, entity: detail.entity, act:'selectOne', id: 'item_unit-fullcont',     dbid: detail.id  });               break;
        case 'otherexpense':     otherexpensefullcont.start({      dest: detail.dest, entity: detail.entity, act:'selectOne', id: 'otherexpense-fullcont',     dbid: detail.id  });         break;
        case 'purchase':         purchasefullcont.start({      dest: detail.dest, entity: detail.entity, act:'selectOne', id: 'purchase-fullcont',     dbid: detail.id  });                 break;
        case 'receivepayment':   receivepaymentfullcont.start({      dest: detail.dest, entity: detail.entity, act:'selectOne', id: 'receivepayment-fullcont',     dbid: detail.id  });     break;
        case 'customercredit':   customercreditfullcont.start({      dest: detail.dest, entity: detail.entity, act:'selectOne', id: 'customercredit-fullcont',     dbid: detail.id  });     break;
        case 'sale':             salefullcont.start({      dest: detail.dest, entity: detail.entity, act:'selectOne', id: 'sale-fullcont',     dbid: detail.id  });                         break;
        case 'sentpayment':      sentpaymentfullcont.start({      dest: detail.dest, entity: detail.entity, act:'selectOne', id: 'sentpayment-fullcont',     dbid: detail.id  });           break;
        case 'providercredit':   providercreditfullcont.start({      dest: detail.dest, entity: detail.entity, act:'selectOne', id: 'providercredit-fullcont',     dbid: detail.id  });     break;
        case 'shipper':          shipperfullcont.start({      dest: detail.dest, entity: detail.entity, act:'selectOne', id: 'shipper-fullcont',     dbid: detail.id  });                   break;
        case 'users':            usersfullcont.start({      dest: detail.dest, entity: detail.entity, act:'selectOne', id: 'users-fullcont',     dbid: detail.id  });                       break;
        case 'company':          companyfullcont.start({      dest: detail.dest, entity: detail.entity, act:'selectOne', id: 'company-fullcont',     dbid: detail.id  });                   break;
        case 'employesspayment': employesspaymentfullcont.start({      dest: detail.dest, entity: detail.entity, act:'selectOne', id: 'employesspayment-fullcont',     dbid: detail.id  }); break;
        case 'equitydeposit':    equitydepositfullcont.start({      dest: detail.dest, entity: detail.entity, act:'selectOne', id: 'equitydeposit-fullcont',     dbid: detail.id  });       break;
        case "accountsPayable": purchaseFullcont2.start({dest: "purchase",entity: "purchase",act: "selectOne",id: "purchase-fullcont2",dbid: detail.id, }); break;
        case "accountsReceivable": saleFullcont2.start({dest: "sale",entity: "sale",act: "selectOne",id: "sale-fullcont2",dbid: detail.id, }); break;
        case "customerProfit": saleFullcont3.start({dest: "sale",entity: "sale",act: "selectOne",id: "sale-fullcont3",dbid: detail.id, }); break;
        case "providerProfit": purchaseFullcont3.start({dest: "purchase",entity: "purchase",act: "selectOne",id: "purchase-fullcont3",dbid: detail.id, }); break;
    }
} 

// Mapa de relaciones entre entidades y sus vistas relacionadas
const entityRelations = {
  purchase: ["purchase", "accountsPayable", "providerProfit"],
  accountsPayable: ["purchase", "accountsPayable", "providerProfit"],
  providerProfit: ["purchase", "accountsPayable", "providerProfit"],
  sale: ["sale", "accountsReceivable", "customerProfit"],
  accountsReceivable: ["sale", "accountsReceivable", "customerProfit"],
  customerProfit: ["sale", "accountsReceivable", "customerProfit"],
  // Agrega más relaciones si es necesario
};

// Mapeo de overrides para los IDs de los fullcont
const destOverrides = {
  accountsPayable: "purchase-fullcont2",
  providerProfit: "purchase-fullcont3",
  accountsReceivable: "sale-fullcont2",
  customerProfit: "sale-fullcont3",
};

// Devuelve el ID de fullcont según la entidad
function getFullcontId(dest) {
  return destOverrides[dest] || `${dest}-fullcont`;
}

// Devuelve todas las vistas relacionadas a una entidad
function getRelatedDests(dest) {
  return entityRelations[dest] || [dest];
}

//if an element has been updated while the fullcont is opened
//if the fullcont is opened on edit mode, alert to the user
// export function control(detail){ //console.log('fullcont WS control>', detail)

//     //verify if the fullcont has been init
//     //if not, just ignore
//     const fullcontHTML = document.getElementById(`${detail.dest}-fullcont`)
//     if( fullcontHTML === null ||  fullcontHTML === undefined ){ return  }


// //console.log('fullcont WS control>', fullcontHTML.classList.contains('dn') )


//     ///if not visible, just ignore
//     if( fullcontHTML.classList.contains('fullcont-show') ){ 

//         ///get the dbid to know what is the entity that is being edited
//         const dbid =  fullcontHTML.getAttribute('data-dbid') 


//         if( dbid === detail.id ){ 
//             update(detail, fullcontHTML)
//         }  

//     }


 

// }/**/

export function control(detail) {
  // console.log('fullcont WS control>', detail);

  // Obtiene todas las vistas relacionadas a la entidad origen
  const relatedDests = getRelatedDests(detail.dest);
  // console.log('relatedDests>', relatedDests);

  relatedDests.forEach((dest) => {
    const fullcontId = getFullcontId(dest);
    const fullcontHTML = document.getElementById(fullcontId);
    // console.log('fullcontHTML>', fullcontHTML);
    if (!fullcontHTML) return;

    if (fullcontHTML.classList.contains("fullcont-show")) {
      const dbid = fullcontHTML.getAttribute("data-dbid");
      if (dbid == detail.id) {
        update({ ...detail, dest }, fullcontHTML);
      }
    }
  });
} /**/

//Here we kows that the the fullcont open, and was edited for another person
//we have to take an action
export function update( detail, fullcontHTML ){ //console.log('fullcont WS update>', detail)

    //mode-view, just notify the user from a snack labe, and update the information on the fullcont
    if( fullcontHTML.classList.contains('mode-view') ){ //console.log( 'TAKE MODE VIEWWWWW'  )
        findDest (detail)
        snack.start( { act:"show", id:"entityUpdate"  } )
        return
    }


    //mode-edit, notify the user that an change has been generate at the same time that he is editing
    //the user decide if get the changes or ignore by a dialog box
    if( fullcontHTML.classList.contains('mode-edit') ){ 
        
      //  console.log( 'TAKE MODE EDITTTTTTTTT'  )
        dialog.start({ act:"show", id:"entityUpdated", dest:detail.dest,  entity: detail.entity, dbid: detail.id, } )
        return
    }

}/**/

//control if an entity was deleted and the fullcont is open
// export function forDeleted(detail){ //console.log('forDeleted', detail)

//     const fullcontHTML = document.getElementById(`${detail.dest}-fullcont`)

//     //if the fullcont don't exits
//     if( fullcontHTML === null ||  fullcontHTML === undefined ){ return  }

//     ///just if the fullcont is visible
//     if( fullcontHTML.classList.contains('fullcont-show') ){ 

//         ///get the dbid to know what is the entity that is being edited
//         const dbid =  parseInt( fullcontHTML.getAttribute('data-dbid') ) 

//         detail.dbid.forEach((id)=>{
//             if(id === dbid ){ 
//                 dialog.start({ act:"show", id:"entityDeleted", entity:detail.entity} )
//             }
//         })

//     }/**/

// }/**/

export function forDeleted(detail) {
  // Obtiene todas las vistas relacionadas a la entidad origen
  const relatedDests = getRelatedDests(detail.dest);

  relatedDests.forEach((dest) => {
    const fullcontId = getFullcontId(dest);
    const fullcontHTML = document.getElementById(fullcontId);

    if (!fullcontHTML) return;

    if (fullcontHTML.classList.contains("fullcont-show")) {
      const dbid = parseInt(fullcontHTML.getAttribute("data-dbid"));
      detail.dbid.forEach((id) => {
        if (id === dbid) {
          dialog.start({
            act: "show",
            id: "entityDeleted",
            entity: detail.entity,
          });
        }
      });
    }
  });
} /**/